import React from "react";
import { Link } from "react-router-dom";
import { FiUpload } from "react-icons/fi";
import { useState, useEffect } from "react";
import ProfilePicture from "./ProfilePicture";
import axios from "axios";
import API_BASE_URL from "../config/api";

export default function BankDetails() {
  // const [imageURL1, setImageURL1] = useState(
  //   sessionStorage.getItem("imageURL1") || ""
  // );
  // const [imageURL2, setImageURL2] = useState(
  //   sessionStorage.getItem("imageURL2") || ""
  // );
  // const [imageURL3, setImageURL3] = useState(
  //   sessionStorage.getItem("imageURL3") || ""
  // );
  // const [imageURL4, setImageURL4] = useState(
  //   sessionStorage.getItem("imageURL4") || ""
  // );
  // const [imageName1, setImageName1] = useState(
  //   sessionStorage.getItem("imageName1") || ""
  // );
  // const [imageName2, setImageName2] = useState(
  //   sessionStorage.getItem("imageName2") || ""
  // );
  // const [imageName3, setImageName3] = useState(
  //   sessionStorage.getItem("imageName3") || ""
  // );
  // const [imageName4, setImageName4] = useState(
  //   sessionStorage.getItem("imageName4") || ""
  // );
  const [bankNameError, setBankNameError] = useState("");
  const [ifscError, setIfscError] = useState("");
  const [accNumberError, setAccNumberError] = useState("");
  const [confirmAccNumberValue, setConfirmAccNumberValue] = useState("");
  const [confirmAccNumberError, setConfirmAccNumberError] = useState("");
  const [branchError, setBranchError] = useState("");
  const [beneficiaryError, setBeneficiaryError] = useState("");
  const [imageError, setImageError] = useState("");
  const [fullName, setFullName] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  // const [panCardFile, setPanCardFile] = useState(
  //   sessionStorage.getItem("panCardFile") || null
  // );
  // const [chequeFile, setChequeFile] = useState(
  //   sessionStorage.getItem("chequeFile") || null
  // );
  // const [gstFile, setGstFile] = useState(
  //   sessionStorage.getItem("gstFile") || null
  // );
  // const [msmeFile, setMsmeFile] = useState(
  //   sessionStorage.getItem("msmeFile") || null
  // );
  const [shouldReload, setShouldReload] = useState(false);

  const [bankNameValue, setBankNameValue] = useState("");
  const [accNumberValue, setAccNumberValue] = useState("");
  const [ifscValue, setIfscValue] = useState("");
  const [branchValue, setBranchValue] = useState("");
  const [accountTypeValue, setAccountTypeValue] = useState("");
  const [beneficiaryValue, setBeneficiaryValue] = useState("");

  // const [originalData, setOriginalData] = useState({ ...formData });
  // const [shouldReload, setShouldReload] = useState(false);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleCancelClick = () => {
    // setFormData({ ...originalData });
    setIsEditing(false);
  };

  const handleSubmit = async () => {
    // Check if the account number and confirm account number match
    if (accNumberValue !== confirmAccNumberValue) {
      alert("Account number and confirm account number must be the same.");
      return; // Stop the form submission if they don't match
    }
    if (
      ifscError ||
      bankNameError ||
      accNumberError ||
      confirmAccNumberError ||
      branchError ||
      beneficiaryError
    ) {
      alert("Please fill in all the mandatory fields in correct format.");
      return;
    }
    if (
      !bankNameValue ||
      !accNumberValue ||
      !ifscValue ||
      !branchValue ||
      !accountTypeValue ||
      !beneficiaryValue
    ) {
      alert("Please fill in all the mandatory fields.");
      return;
    }
    const token = sessionStorage.getItem("Token");

    // Check if the form data is being captured correctly
    console.log({
      bankName: bankNameValue,
      accountNumber: accNumberValue,
      ifsc: ifscValue,
      branchName: branchValue,
      accountType: accountTypeValue,
      beneficiaryName: beneficiaryValue,
      // panCardFile: panCardFile,
      // chequeFile: chequeFile,
      // gstFile: gstFile,
      // msmeFile: msmeFile,
    });

    // Make sure form data is appended correctly
    const formData = new FormData();
    formData.append("bankName", bankNameValue);
    formData.append("accountNumber", accNumberValue);
    formData.append("ifsc", ifscValue);
    formData.append("branchName", branchValue);
    formData.append("accountType", accountTypeValue);
    formData.append("beneficiaryName", beneficiaryValue);

    // Append the files only if they are present
    // if (panCardFile) formData.append("pan_card", panCardFile);
    // if (chequeFile) formData.append("cancelled_cheque", chequeFile);
    // if (gstFile) formData.append("gst_certificate", gstFile);
    // if (msmeFile) formData.append("msme_certificate", msmeFile);

    // Check if files are attached correctly
    for (let pair of formData.entries()) {
      console.log(pair[0] + ": " + (pair[1].name || pair[1])); // Log the field name and file name or value
    }

    // Send the request
    try {
      const response = await axios.put(
        `${API_BASE_URL}/v3/bankDetails/${token}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      console.log("Response:", response.data);
      setIsEditing(false);
    } catch (error) {
      console.error("Error submitting form:", error);
      if (error.response) {
        console.log("Error details:", error.response.data);
      }
    }
  };

  useEffect(() => {
    const getUserInfo = async () => {
      const token = sessionStorage.getItem("Token");
      try {
        const response = await axios.get(
          `${API_BASE_URL}/v1/userById/${token}`
        );
        const userData = response.data.data[0];

        setFullName(userData.full_name || "");
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };
    getUserInfo();
  }, []);

  useEffect(() => {
    const getUserInfo = async () => {
      const token = sessionStorage.getItem("Token");
      if (!token) {
        console.error("Token is missing.");
        return;
      }

      try {
        const response = await axios.get(
          `${API_BASE_URL}/v1/bankDetailsById/${token}`
        );

        // Check if the data exists
        const userData = response.data?.data?.[0];
        if (!userData) {
          console.warn("No bank details found.");
          // Optionally, reset all fields to default values
          setBankNameValue("");
          setAccNumberValue("");
          setConfirmAccNumberValue("");
          setIfscValue("");
          setBranchValue("");
          setAccountTypeValue("");
          setBeneficiaryValue("");

          // setPanCardFile(null);
          // setChequeFile(null);
          // setGstFile(null);
          // setMsmeFile(null);

          // setImageURL1("");
          // setImageURL2("");
          // setImageURL3("");
          // setImageURL4("");

          // setImageName1("");
          // setImageName2("");
          // setImageName3("");
          // setImageName4("");

          return;
        }

        // If data exists, update the state
        setBankNameValue(userData.bank_name || "");
        setAccNumberValue(userData.account_number || "");
        setConfirmAccNumberValue(userData.account_number || "");
        setIfscValue(userData.ifsc_code || "");
        setBranchValue(userData.branch_name || "");
        setAccountTypeValue(userData.account_type || "");
        setBeneficiaryValue(userData.beneficiary_name || "");

        // setPanCardFile(userData.pan_copy || null);
        // setChequeFile(userData.cancelled_cheque_copy || null);
        // setGstFile(userData.gst_certificate_copy || null);
        // setMsmeFile(userData.msme_certificate_copy || null);

        // setImageURL1(userData.pan_copy || "");
        // setImageURL2(userData.cancelled_cheque_copy || "");
        // setImageURL3(userData.gst_certificate_copy || "");
        // setImageURL4(userData.msme_certificate_copy || "");

        // setImageName1(userData.pan_copy?.split("/").pop() || "");
        // setImageName2(userData.cancelled_cheque_copy?.split("/").pop() || "");
        // setImageName3(userData.gst_certificate_copy?.split("/").pop() || "");
        // setImageName4(userData.msme_certificate_copy?.split("/").pop() || "");

        // Store in sessionStorage
        // sessionStorage.setItem("bankName", userData.bank_name || "");
        // sessionStorage.setItem("accountNumber", userData.account_number || "");
        // sessionStorage.setItem(
        //   "confirmAccountNumber",
        //   userData.account_number || ""
        // );
        // sessionStorage.setItem("ifsc", userData.ifsc_code || "");
        // sessionStorage.setItem("branchName", userData.branch_name || "");
        // sessionStorage.setItem("accountType", userData.account_type || "");
        // sessionStorage.setItem(
        //   "beneficiaryName",
        //   userData.beneficiary_name || ""
        // );

        // sessionStorage.setItem(
        //   "chequeFile",
        //   userData.cancelled_cheque_copy || ""
        // );
        // sessionStorage.setItem("gstFile", userData.gst_certificate_copy || "");
        // sessionStorage.setItem(
        //   "msmeFile",
        //   userData.msme_certificate_copy || ""
        // );

        // sessionStorage.setItem("imageURL1", userData.pan_copy || "");
        // sessionStorage.setItem(
        //   "imageURL2",
        //   userData.cancelled_cheque_copy || ""
        // );
        // sessionStorage.setItem(
        //   "imageURL3",
        //   userData.gst_certificate_copy || ""
        // );
        // sessionStorage.setItem(
        //   "imageURL4",
        //   userData.msme_certificate_copy || ""
        // );
        // sessionStorage.setItem(
        //   "imageName1",
        //   userData.pan_copy?.split("/").pop() || ""
        // );
        // sessionStorage.setItem(
        //   "imageName2",
        //   userData.cancelled_cheque_copy?.split("/").pop() || ""
        // );
        // sessionStorage.setItem(
        //   "imageName3",
        //   userData.gst_certificate_copy?.split("/").pop() || ""
        // );
        // sessionStorage.setItem(
        //   "imageName4",
        //   userData.msme_certificate_copy?.split("/").pop() || ""
        // );
      } catch (error) {
        console.error("Failed to fetch user data:", error.message);
        if (error.response) {
          console.error("Response data:", error.response.data);
          console.error("Status code:", error.response.status);
        }
      }
    };
    getUserInfo();
  }, [shouldReload]);

  const validateImageFile = (file) => {
    const validTypes = ["image/jpeg", "image/jpg", "application/pdf"];
    return validTypes.includes(file.type);
  };

  // const handleImageUpload1 = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     if (validateImageFile(file)) {
  //       setPanCardFile(file);
  //       setImageName1(file.name);
  //       setImageURL1(URL.createObjectURL(file));
  //       setImageError("");
  //     } else {
  //       setImageError("Only .jpeg, .jpg, and .pdf files are allowed.");
  //     }
  //   }
  // };

  // const handleImageUpload2 = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     if (validateImageFile(file)) {
  //       setChequeFile(file); // Set the actual file object
  //       setImageName2(file.name);
  //       setImageURL2(URL.createObjectURL(file)); // Show preview if necessary
  //       setImageError(""); // Clear any error
  //     } else {
  //       setImageError("Only .jpeg, .jpg, and .pdf files are allowed.");
  //     }
  //   }
  // };

  // const handleImageUpload3 = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     if (validateImageFile(file)) {
  //       setGstFile(file); // Set the actual file object
  //       setImageName3(file.name);
  //       setImageURL3(URL.createObjectURL(file)); // Show preview if necessary
  //       setImageError(""); // Clear any error
  //     } else {
  //       setImageError("Only .jpeg, .jpg, and .pdf files are allowed.");
  //     }
  //   }
  // };

  // const handleImageUpload4 = (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     if (validateImageFile(file)) {
  //       setMsmeFile(file); // Set the actual file object
  //       setImageName4(file.name);
  //       setImageURL4(URL.createObjectURL(file)); // Show preview if necessary
  //       setImageError(""); // Clear any error
  //     } else {
  //       setImageError("Only .jpeg, .jpg, and .pdf files are allowed.");
  //     }
  //   }
  // };

  //----------validation for input fields----------
  const handleBankNameChange = (e) => {
    const value = e.target.value.trimStart();
    const regex = /^[a-zA-Z\s]{0,50}$/;

    if (regex.test(value)) {
      setBankNameValue(value);
      setBankNameError("");
    } else {
      setBankNameValue("");
      setBankNameError("Please Enter a valid Bank name");
    }
  };

  const handleIfscChange = (e) => {
    const value = e.target.value.toUpperCase().trim();
    const regex = /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/;
    if (value.length > 11) {
      return;
    }
    if (regex.test(value)) {
      setIfscValue(value);
      setIfscError("");
    } else {
      setIfscValue(value);
      setIfscError(
        "Please Enter a valid IFSC code (SBIN0001234 or HDFC0ABCDEF)"
      );
    }
  };

  const handleAccountNumber = (e) => {
    const value = e.target.value.trim();
    const regex = /^[0-9]*$/;

    if (regex.test(value) && value.length <= 16) {
      setAccNumberValue(value);
      setAccNumberError("");
    } else {
      setAccNumberError("Please Enter Account Number of 16 Digits");
    }
  };

  const handleConfirmAccNumber = (e) => {
    const value = e.target.value.trim();
    const regex = /^[0-9]{0,16}$/;

    if (regex.test(value)) {
      setConfirmAccNumberValue(value);
      if (value === accNumberValue) {
        setConfirmAccNumberError("");
      } else {
        setConfirmAccNumberError("Account numbers do not match");
      }
    } else {
      // setConfirmAccNumberValue("");
    }
  };

  const handleBranchChange = (e) => {
    const value = e.target.value.trimStart();
    const regex = /^[a-zA-Z\s]{0,30}$/;

    if (regex.test(value)) {
      setBranchValue(value);
      setBranchError("");
    } else {
      setBranchError("Please Enter a valid Branch name");
    }
  };

  const handleBeneficiaryChange = (e) => {
    const value = e.target.value.trimStart();
    const regex = /^[a-zA-Z\s]{0,50}$/;

    if (regex.test(value)) {
      setBeneficiaryValue(value);
      setBeneficiaryError("");
    } else {
      setBeneficiaryError("Please Enter a valid Branch name");
    }
  };

  //------API Integration------

  return (
    <>
      <div className="flex">
        <button
          className="my-5 text-[#FEC961] text-[1.6rem] w-auto h-[5rem] ml-[12.5%]"
          style={{ fontFamily: "Poppins, sanSerif" }}
        >
          <Link to="/account-details">Account Details</Link>
        </button>
        <button
          className="my-5 text-[#FEC961] text-[1.6rem] w-auto h-[5rem] ml-[4%]"
          style={{ fontFamily: "Poppins, sanSerif" }}
        >
          <Link to="/social-media">Social Media</Link>
        </button>
        <button
          className="my-5 text-[#FF6C2F] text-[1.6rem] w-auto h-[5rem] ml-[4%]"
          style={{ fontFamily: "Poppins, sanSerif" }}
        >
          <Link to="/bank-details">Bank Details</Link>
          <hr />
        </button>
      </div>
      <div className="container1">
        <div className="profileBar w-[28%]  bg-[#ffffff0d] rounded-md">
          <ProfilePicture artistName={fullName} />
        </div>
        <div className="formDetails">
          <div>
            <label
              htmlFor=""
              className="flex font-[Poppins] text-[#FFFFFF] mt-[1%] mx-0 w-[80%] flex-row"
            >
              Name of the Bank <span className="text-[#FF6C2F]">*</span>
            </label>
            <input
              type=""
              className="rounded-[5px] bg-[#4c4c4c] w-[35rem] h-[2.8rem] text-[#FFFFFF] font-[Poppins] pl-[0.7rem]"
              placeholder=""
              required
              value={bankNameValue}
              onChange={handleBankNameChange}
              readOnly={!isEditing}
            />
          </div>
          {bankNameError && (
            <span className="error-text" style={{ color: "red" }}>
              {bankNameError}
            </span>
          )}
          <div>
            <label
              htmlFor=""
              className="font-[Poppins] text-[#FFFFFF] mt-[4%] flex w-[80%] flex-row"
            >
              IFSC<span className="text-[#FF6C2F]">*</span>
            </label>
            <input
              type="text"
              className="rounded-[5px] bg-[#4c4c4c] w-[35rem] h-[2.8rem] text-[#FFFFFF] font-[Poppins] pl-[0.7rem]"
              placeholder=""
              required
              value={ifscValue}
              onChange={handleIfscChange}
              readOnly={!isEditing}
            />
          </div>
          {ifscError && (
            <span className="error-text" style={{ color: "red" }}>
              {ifscError}
            </span>
          )}
          <div>
            <label
              htmlFor=""
              className="font-[Poppins] text-[#FFFFFF] mt-[4%] flex w-[80%] flex-row"
            >
              Account Number<span className="text-[#FF6C2F]">*</span>
            </label>
            <input
              type=""
              className="rounded-[5px] bg-[#4c4c4c] w-[35rem] h-[2.8rem] text-[#FFFFFF] font-[Poppins] pl-[0.7rem]"
              placeholder=""
              required
              value={accNumberValue}
              onChange={handleAccountNumber}
              readOnly={!isEditing}
            />
          </div>
          <div>
            <label
              htmlFor=""
              className="font-[Poppins] text-[#FFFFFF] mt-[4%] flex w-[80%] flex-row"
            >
              Confirm Account Number<span className="text-[#FF6C2F]">*</span>
            </label>
            <input
              type=""
              className="rounded-[5px] bg-[#4c4c4c] w-[35rem] h-[2.8rem] text-[#FFFFFF] font-[Poppins] pl-[0.7rem]"
              placeholder=""
              required
              value={confirmAccNumberValue}
              onChange={handleConfirmAccNumber}
              readOnly={!isEditing}
            />
          </div>
          {confirmAccNumberError && (
            <span className="error-text" style={{ color: "red" }}>
              {confirmAccNumberError}
            </span>
          )}

          <div className="flex flex-row items-center">
            <div className="mt-[4%] grow-[0.58]">
              <label htmlFor="" className="font-[Poppins] text-[#FFFFFF]">
                Branch<span className="text-[#FF6C2F]">*</span>
              </label>
            </div>
            <div className="mt-[4%]">
              <label htmlFor="" className="font-[Poppins] text-[#FFFFFF]">
                Account Type<span className="text-[#FF6C2F]">*</span>
              </label>
            </div>
          </div>
          <div>
            <input
              type="text"
              className="rounded-[5px] bg-[#4c4c4c] w-[17rem] h-[2.8rem] text-[#FFFFFF] font-[Poppins] pl-[0.7rem]"
              placeholder=""
              required
              value={branchValue}
              onChange={handleBranchChange}
              readOnly={!isEditing}
            />
            <select
              className="rounded-[5px] bg-[#4c4c4c] w-[17rem] h-[2.8rem] ml-3 text-[#FFFFFF] font-[Poppins] pl-[2%] outline-none"
              value={accountTypeValue}
              onChange={(e) => setAccountTypeValue(e.target.value)} // Add this handler
              // disabled={!isEditing} // Uncomment if needed
            >
              <option value="" disabled>
                Select Account Type
              </option>
              <option value="Savings">Savings Account</option>
              <option value="Current">Current Account</option>
              <option value="Salary">Salary Account</option>
              <option value="NRI">NRI Account</option>
            </select>
          </div>

          <div>
            <label
              htmlFor=""
              className="flex font-[Poppins] text-[#FFFFFF] mt-[4%] mx-0 w-[80%] flex-row"
            >
              Beneficiary Name<span className="text-[#FF6C2F]">*</span>
            </label>
            <input
              type="text"
              className="rounded-[5px] bg-[#4c4c4c] w-[35rem] h-[2.8rem] text-[#FFFFFF] font-[Poppins] pl-[0.7rem]"
              placeholder="Artist Aloud"
              required
              value={beneficiaryValue}
              onChange={handleBeneficiaryChange}
              readOnly={!isEditing}
            />
          </div>
          <div className="font-[Poppins] text-[#FFFFFF] w-full mt-5">
            {/* First row: PAN & Cancelled Cheque */}
            {/* <div className="flex justify-between items-center w-full mb-2">
              <label htmlFor="" className="font-[Poppins]">
                Upload copy of PAN<span className="text-[#FF6C2F]">*</span>
              </label>
              <label htmlFor="" className="font-[Poppins]">
                Upload copy of Cancelled Cheque
                <span className="text-[#FF6C2F]">*</span>
              </label>
            </div> */}

            <div className="flex items-center w-full">
              {/* Upload PAN */}
              {/* <div className="w-[18rem] flex items-center">
                <div className=" w-[7rem]">
                  <input
                    type="file"
                    id="upload_file1"
                    accept=".jpeg,.jpg,.pdf"
                    hidden
                    onChange={(event) => handleImageUpload1(event)}
                    disabled={!isEditing}
                  />
                  <label
                    htmlFor="upload_file1"
                    className="flex items-center bg-[#4c4c4c] rounded-md w-full px-4 py-2 text-[#e2e2e2] cursor-pointer"
                  >
                    <span className="flex-grow">Upload</span>
                    <FiUpload className="text-[#FF6C2F]" />
                  </label>
                </div>
                <div className="w-[3rem] pl-2 max-h-[2.8rem] overflow-hidden">
                  {imageName1 && (
                    <a
                      href={imageURL1}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-[#FF6C2F]"
                      style={{
                        display: "inline-block",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      {imageName1}
                    </a>
                  )}
                </div>
              </div> */}

              {/* Upload Cancelled Cheque */}
              {/* <div className="flex items-center">
                <div className=" w-[7rem]">
                  <input
                    type="file"
                    id="upload_file2"
                    accept=".jpeg,.jpg,.pdf"
                    hidden
                    onChange={(event) => handleImageUpload2(event)}
                    disabled={!isEditing}
                  />
                  <label
                    htmlFor="upload_file2"
                    className="flex items-center bg-[#4c4c4c] rounded-md w-full px-4 py-2 text-[#e2e2e2] cursor-pointer"
                  >
                    <span className="flex-grow">Upload</span>
                    <FiUpload className="text-[#FF6C2F]" />
                  </label>
                </div>
                <div className="w-[3rem] pl-2 max-h-[2.8rem] overflow-hidden">
                  {imageName2 && (
                    <a
                      href={imageURL2}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-[#FF6C2F]"
                      style={{
                        display: "inline-block",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      {imageName2}
                    </a>
                  )}
                </div>
              </div> */}
            </div>

            {/* Error message for first row */}
            {/* {imageError && (
              <span className="block mt-2 text-red-500 text-sm">
                {imageError}
              </span>
            )} */}

            {/* Second row: GST Certificate & MSME Certificate */}
            {/* <div className="flex justify- items-center w-full mt-7 mb-2 ">
              <label htmlFor="" className="font-[Poppins]">
                Upload copy of GST Certificate
                <span className="text-[#FF6C2F]">*</span>
              </label>
              <label htmlFor="" className="font-[Poppins] ml-[4%]">
                Upload copy of MSME Certificate
                <span className="text-[#FF6C2F]">*</span>
              </label>
            </div> */}

            {/* <div className="flex items-center w-full"> */}
            {/* Upload GST Certificate */}
            {/* <div className="w-[18rem] flex items-center">
                <div className=" w-[7rem]">
                  <input
                    type="file"
                    id="upload_file3"
                    accept=".jpeg,.jpg,.pdf"
                    hidden
                    onChange={(event) => handleImageUpload3(event)}
                    disabled={!isEditing}
                  />
                  <label
                    htmlFor="upload_file3"
                    className="flex items-center bg-[#4c4c4c] rounded-md w-full px-4 py-2 text-[#e2e2e2] cursor-pointer"
                  >
                    <span className="flex-grow">Upload</span>
                    <FiUpload className="text-[#FF6C2F]" />
                  </label>
                </div>
                <div className="w-[3rem] pl-2 max-h-[2.8rem] overflow-hidden">
                  {imageName3 && (
                    <a
                      href={imageURL3}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-[#FF6C2F]"
                      style={{
                        display: "inline-block",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      {imageName3}
                    </a>
                  )}
                </div>
              </div> */}

            {/* Upload MSME Certificate */}
            {/* <div className="flex items-center">
                <div className=" w-[7rem]">
                  <input
                    type="file"
                    id="upload_file4"
                    accept=".jpeg,.jpg,.pdf"
                    hidden
                    onChange={(event) => handleImageUpload4(event)}
                    disabled={!isEditing}
                  />
                  <label
                    htmlFor="upload_file4"
                    className="flex items-center bg-[#4c4c4c] rounded-md w-full px-4 py-2 text-[#e2e2e2] cursor-pointer"
                  >
                    <span className="flex-grow">Upload</span>
                    <FiUpload className="text-[#FF6C2F]" />
                  </label>
                </div>
                <div className="w-[3rem] pl-2 max-h-[2.8rem] overflow-hidden">
                  {imageName4 && (
                    <a
                      href={imageURL4}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-sm text-[#FF6C2F]"
                      style={{
                        display: "inline-block",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "100%",
                      }}
                    >
                      {imageName4}
                    </a>
                  )}
                </div>
              </div> */}
            {/* </div> */}

            {/* Error message for second row */}
            {imageError && (
              <span className="block mt-2 text-red-500 text-sm">
                {imageError}
              </span>
            )}
          </div>

          <div>
            {isEditing ? (
              <div className="flex justify-end mt-[14%]">
                <button
                  className="text-[#FFFFFF] text-[100%] w-[6rem] h-[3rem] bg-[#6E6E6E] rounded-md hover:bg-[#484848] active:bg-[#484848]"
                  style={{
                    fontFamily: "Poppins, sanSerif",
                    padding: "8px 16px",
                    marginBottom: "40px",
                  }}
                  onClick={handleCancelClick}
                >
                  Cancel
                </button>
                <button
                  className="mb-[10%] text-[#FFFFFF] text-[100%] w-[6rem] h-[3rem] bg-[#FF6C2F] rounded-md ml-[1%] hover:bg-[#d95a25] active:bg-[#c15122]"
                  style={{
                    fontFamily: "Poppins, sanSerif",
                    padding: "8px 16px",
                  }}
                  onClick={handleSubmit}
                >
                  Save
                </button>
              </div>
            ) : (
              <div className="flex justify-end mt-[14%]">
                <button
                  className="text-[#FFFFFF] text-[100%] w-[6rem] h-[3rem] bg-[#FF6C2F] rounded-md mb-[10%] hover:bg-[#d95a25] active:bg-[#c15122]"
                  style={{
                    fontFamily: "Poppins, sanSerif",
                    padding: "8px 16px",
                  }}
                  onClick={handleEditClick}
                >
                  Edit
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
